export default {
	"RuleClick.ActivityRules": "活动规则"
}